/**
 * ResultCache — tiny per-key TTL cache that delegates persistence to an
 * injected CacheStorage (localStorage in the browser).
 */

import type { CacheStorage } from "./cache-storage";

export interface CacheEntry<T> {
  data: T;
  fetchedAt: number;
}

export class ResultCache<T> {
  constructor(
    private readonly ttlMs: number,
    private readonly storage: CacheStorage
  ) {}

  get(key: string): T | undefined {
    const entry = this.storage.getEntry<T>(key);
    if (!entry) return undefined;
    if (Date.now() - entry.fetchedAt > this.ttlMs) {
      this.storage.removeEntry(key);
      return undefined;
    }
    return entry.data;
  }

  set(key: string, data: T): void {
    this.storage.setEntry(key, { data, fetchedAt: Date.now() });
  }
}
